jQuery(document).ready(function($) {
   var categorySlug = $('.home-banner').data('cat');
    // Обробка кліку на кнопки сортування
    $('.sort .select_list button').on('click', function(e) {
        e.preventDefault();
        var sortBy = $(this).data('sort');
        // Додаємо клас 'active' до натиснутої кнопки та забираємо у інших
        $('.sort .select_list button').removeClass('active');
        $(this).addClass('active');

        var filterKey = '';
        var filterValue = '';

        // Перевіряємо, чи є активний фільтр
        $('.filter .select_list button').each(function() {
            if ($(this).hasClass('active')) {
                filterKey = $(this).data('filter');
                filterValue = $(this).data('value');
            }
        });

        // Викликаємо AJAX для сортування
        $.ajax({
            url: ajax_sort_by.ajax_url,
            type: 'POST',
            data: {
                action: 'sort_bonus_casino',
                sort_by: sortBy,
                sort_by: sortBy,
                filter_key: filterKey,    // Передаємо активний фільтр, якщо є
                filter_value: filterValue, // Передаємо значення активного фільтра
                category_slug: categorySlug,
                request_type: filterKey ? 'filter' : 'sort' // Визначаємо тип запиту
            },
            success: function(response) {
                $('.casino-list').html(response);  // Оновлюємо список казино для сортування
                $('.sort').removeClass('open');
                initMoreTrigger();
            }
        });
    });

    // Обробка кліку на кнопки фільтрації
    $('.filter button').on('click', function(e) {
        e.preventDefault();

        var sortBy = '';
        $('.sort .select_list button').each(function() {
            if ($(this).hasClass('active')) {
                sortBy = $(this).data('sort'); // Отримуємо значення сортування для активної кнопки
            }
        });

        $('.filter .select_list button').removeClass('active');
        $(this).addClass('active');

        var filterValue = $(this).data('value');
        var filterKey = $(this).data('filter'); // Наприклад 'deposits' або 'bonus'

        // Викликаємо AJAX для фільтрації
        $.ajax({
            url: ajax_sort_by.ajax_url,
            type: 'POST',
            data: {
                action: 'sort_bonus_casino',
                filter_key: filterKey,
                filter_value: filterValue,
                sort_by: sortBy,
                category_slug: categorySlug,
                request_type: 'filter' // Передаємо маркер типу запиту
            },
            success: function(response) {
                $('.casino-list').html(response); // Оновлюємо список казино для фільтрації
                $('.filter').removeClass('open');
                initMoreTrigger();
            }
        });
    });

    // Обробка кліку на кнопку скидання фільтрів
    $('#reset_filter').on('click', function(e) {
        e.preventDefault();
        var sortBy = '';
        $('.sort .select_list button').each(function() {
            if ($(this).hasClass('active')) {
                sortBy = $(this).data('sort'); // Отримуємо значення сортування для активної кнопки
            }
        });

        // Викликаємо AJAX для скидання фільтрів і сортування
        $.ajax({
            url: ajax_sort_by.ajax_url,
            type: 'POST',
            data: {
                action: 'sort_bonus_casino',
                sort_by: sortBy, // Використовуємо сортування для відображення
				category_slug: categorySlug,
                request_type: 'sort' // Тип запиту - сортування
            },
            success: function(response) {
                $('.casino-list').html(response);  // Оновлюємо список казино
                initMoreTrigger();
            }
        });
    });

    function initMoreTrigger() {
        $('.more-trigger').click(function() {
            $(this).parents('.casino-card--bonuse').toggleClass('open-more').siblings('.casino-card--bonuse').removeClass('open-more');
        });

        $(document).mouseup(function(e) {
            let casinoBonuseCart = $(".casino-card--bonuse");
            if (!casinoBonuseCart.is(e.target) && casinoBonuseCart.has(e.target).length === 0) {
                casinoBonuseCart.removeClass('open-more');
            }
        });
    }

    $(document).on('click', '.coupon_copy', function() {
        let $temp = $("<input>");
        let text = $(this).siblings('.coupon_text');
        $("body").append($temp);
        $temp.val(text.text()).select();
        document.execCommand("copy");
        $temp.remove();
        $(this).parents('.modal').find('.modal_notification').addClass('visible success');
    });

    $(document).on('click', '.modal_close', function() {
        $('.modal').removeClass('open');
        $('body').removeClass('no-scroll');
        $('.modal_notification').removeClass('visible');
    });
    $(document).on('click', '.modal_notification .close', function() {
        $('.modal_notification').removeClass('visible');
    });

});
